import React from "react";
import { Modal, Form, Input, Button } from "antd";
import { noop } from "lodash";

const ActionModalForm = ({
  data = {},
  visible,
  onSubmit,
  onCancel,
  onCloseClick,
  title,
  submitText,
  formItems = [],
  footer,
  columnData,
  isAssignTechnicianButton,
  ...props
}) => {
  const [form] = Form.useForm();
  const onOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        await onSubmit(values);
        form.resetFields();
      })
      .catch(noop);
  };

  const onModalClose = () => {
    onCloseClick();
  };

  const modalFooter = (
    <>
      {footer}

      <Button onClick={onOk} type="primary">
        {submitText}
      </Button>
    </>
  );

  return (
    <Modal
      visible={visible}
      onCancel={onModalClose}
      onOk={onOk}
      title={
        submitText === "Confirm Payment"
          ? `Order ID: ${columnData.orderid} (₹ ${columnData.total_payable})`
          : `Order ID: ${columnData.orderid}`
      }
      okText={submitText}
      destroyOnClose
      footer={modalFooter}
      {...props}
    >
      <div>
        <p>{columnData.product_name}</p>
        <p>{`Patient Name: ${columnData.patient_name}`}</p>
        <p>{`Mode: ${columnData.module}`}</p>
        <p>{`Schedule : ${columnData.schedule_date} - ${columnData.schedule_time}`}</p>
        <p>{`Test Ordered: ${columnData.tests}`}</p>
        <p>{`Branch Name: ${columnData.branch_name}`}</p>
        <p>{`Payment Status: ${columnData.payment_status}`}</p>
        <p>{`Total Payable: ${columnData.currency}${columnData.total_payable}`}</p>
      </div>
      <Form form={form} initialValues={data} layout="vertical">
        {formItems.map(({ Component, ...formItem }) => (
          <Form.Item name={formItem.key} {...formItem}>
            {Component || <Input />}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
export default ActionModalForm;
